module.exports = __webpack_public_path__ + "img/zycp003.403de099.jpg";